const translations = {
  mk: {
    nav: {
      home: "Почетна",
      news: "Вести",
      about: "За нас",
      documents: "Документи",
      annualReports: "Годишни извештаи",
      projects: "Проекти",
      tagline: "Здружение за култура, спорт и образование",
      languages: {
        mk: "МК",
        en: "EN",
      },
    },
    home: {
      latestNews: "Најнови вести",
      impactHeading: "Нашето влијание",
      heroTagline: "Здружение за култура, спорт и образование",
      heroSubtitle: "Градиме мостови меѓу заедниците во Гостивар преку култура, спорт и образование од 2015 година.",
      readMore: "Прочитај повеќе",
      viewAllNews: "Сите вести",
      missionLabel: "Нашата мисија",
      missionText: "Промовирање на традиционалните вредности, зајакнување на меѓуетничките односи и охрабрување на младите да се вклучат во културата, спортот и образованието.",
      learnMore: "Дознај повеќе",
      statProjects: "Проекти",
      statYears: "Години",
      statCommunity: "Заедница",
    },
    news: {
      headline: "Вести и приказни",
    },
    about: {
      headline: "Кои сме ние",
      title: "За нас",
      imageAlt: "Лого на ЗКСО Анисија",
      partnersHeading: "Нашите партнери",
      content: [
        "Здружението за култура, спорт и образование „Анисија“ од Гостивар е основано на 14 септември 2015 година и е регистрирано во Централниот регистар во Гостивар.",
        "Здружението е создадено со цел промовирање на традиционалните вредности, зајакнување на меѓуетничките односи меѓу различните заедници кои живеат во Гостивар и охрабрување на младите да се вклучат во културата, спортот и образованието. Во изминатите години, ЗКСО „Анисија“ активно придонесува кон збогатување на културниот и забавниот живот во градот, помагајќи во зачувување, негување и претставување на богатото културно наследство на македонскиот народ во Полошкиот регион и низ целата држава.",
        "Од своето основање, здружението учествувало во бројни проекти од областа на културата и спортот, во партнерство со други здруженија и организации. Организира и учествува на промоции на книги, литературни читања, како и на планинарски тури.",
      ],
    },
    newsDetail: {
      backToNews: "Назад кон вестите",
      notFound: "Жалам, не можевме да ја пронајдеме таа вест.",
      metaSeparator: " · ",
    },
    annualReports: {
      headline: "Годишни извештаи",
      intro:
        "На оваа страница можете да ги отворите или преземете годишните извештаи на ЗКСО „Анисија“.",
      reportTitlePrefix: "Годишен извештај",
      open: "Отвори",
      download: "Преземи",
      formatLabel: "PDF документ",
      unavailable: "Овој документ моментално не е достапен.",
    },
    projects: {
      headline: "Реализирани проекти:",
      serialHeader: "Реден број",
      titleHeader: "Наслов на проект/иницијатива/активност",
      periodHeader: "Период на спроведување",
      locationHeader: "Општина/регион/локација на спроведување",
      donorHeader: "Донатор, вкупен буџет",
      locationValue: "Гостивар/Gostivar",
    },
    footer: {
      heading: "Контакт",
      rights: "Сите права задржани.",
    },
  },
  en: {
    nav: {
      home: "Home",
      news: "News",
      about: "About us",
      documents: "Documents",
      annualReports: "Annual reports",
      projects: "Projects",
      tagline: "Association for Culture, Sports and Education",
      languages: {
        mk: "MK",
        en: "EN",
      },
    },
    home: {
      latestNews: "Latest News",
      impactHeading: "Our Impact",
      heroTagline: "Association for Culture, Sports and Education",
      heroSubtitle: "Building bridges between communities in Gostivar through culture, sports, and education since 2015.",
      readMore: "Read more",
      viewAllNews: "All news",
      missionLabel: "Our Mission",
      missionText: "Promoting traditional values, strengthening multiethnic relations, and encouraging young people to engage in culture, sports, and education.",
      learnMore: "Learn more",
      statProjects: "Projects",
      statYears: "Years",
      statCommunity: "Community",
    },
    news: {
      headline: "News & Stories",
    },
    about: {
      headline: "Who we are",
      title: "About us",
      imageAlt: "Anisija logo",
      partnersHeading: "Our Partners",
      content: [
        "The Association for Culture, Sports and Education “Anisija” from Gostivar was founded on September 14, 2015, and is registered in the Central Register in Gostivar.",
        "The association was established to promote traditional values, strengthen multiethnic relations among the different communities living in Gostivar, and encourage young people to engage in culture, sports, and education. Over the past years, ZKSO “Anisija” has actively contributed to enriching the cultural and entertainment life of the town, helping to preserve, nurture, and showcase the rich cultural heritage of the Macedonian people in the Polog region and across the country.",
        "Since its establishment, the association has taken part in numerous projects in the fields of culture and sports, in partnership with other associations and organisations. It organises and participates in book promotions, literary readings, as well as hiking tours.",
      ],
    },
    newsDetail: {
      backToNews: "Back to news",
      notFound: "Sorry, we could not find that article.",
      metaSeparator: " - ",
    },
    annualReports: {
      headline: "Annual reports",
      intro:
        "On this page, you can open or download the annual reports of ACSE “Anisija”.",
      reportTitlePrefix: "Annual report",
      open: "Open",
      download: "Download",
      formatLabel: "PDF document",
      unavailable: "This document is currently unavailable.",
    },
    projects: {
      headline: "Implemented projects:",
      serialHeader: "No.",
      titleHeader: "Project/initiative/activity title",
      periodHeader: "Implementation period",
      locationHeader: "Municipality/region/location of implementation",
      donorHeader: "Donor, total budget",
      locationValue: "Гостивар/Gostivar",
    },
    footer: {
      heading: "Stay in touch",
      rights: "All rights reserved.",
    },
  },
};

export default translations;
